export default {
  priority: 101,
  permissions: ['360EvaluationMenu/QuestionMenu/'] , //['QuestionGroupMenu','QuestionnaireMenu', 'QuestionAssignMenu'],
  name: app.translate('routes.home.evaluation-360.Question'),
  icon: 'calendar-question',
  drawer: true,
};
